import { Box, Modal, Spinner } from '@ksyos/design-system';
import { HardwareProcessStatus } from '@common/enums/hardwareProcessStatus';

type HolterConfigureProcessingModalProps = Readonly<{
    processStatus?: HardwareProcessStatus;
}>;

export function HolterConfigureProcessingModal(props: HolterConfigureProcessingModalProps) {
    const { processStatus } = props;

    return (
        <Modal
            closeOnEsc={false}
            isOpen
            onClose={() => undefined}
            size="small"
        >
            <Modal.Header>Een ogenblik geduld...</Modal.Header>
            <Modal.Body>
                {processStatus &&
                    [HardwareProcessStatus.starting, HardwareProcessStatus.running].includes(processStatus) && (
                        <Box>
                            Het instellen van de recorder is gestart{' '}
                            <Spinner style={{ marginLeft: 'var(--kds-spacing-1)' }} />
                        </Box>
                    )}
            </Modal.Body>
            <Modal.Footer />
        </Modal>
    );
}
